import { defaultAxios, IParams } from './base';

export interface IFetchBaseUserAgreed extends IParams {
  userKey?: string;
  appUserId?: string;
  appUserPartIdx?: string;
  agreeType?: string;
}

//lgu 약관 동의 체크
export const fetchBaseUserAgreed = async (params: IFetchBaseUserAgreed) => {
  return await defaultAxios().post(`/base/userAgreed`, params);
};
